"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useTitle_1 = __importDefault(require("react-use/lib/useTitle"));
var Layout_1 = require("../containers/Layout");
function useTitle(title) {
    var _a = (0, react_1.useContext)(Layout_1.TitleContext), setTitle = _a[1];
    (0, useTitle_1.default)(title);
    (0, react_1.useEffect)(function () { return setTitle(title); }, [title, setTitle]);
}
exports.default = useTitle;
